import {
     CButton,
     CModal,
     CModalBody,
     CModalFooter
} from '@coreui/react';
import cloneDeep from 'lodash/cloneDeep';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { fetchAllRulesRequest, setActiveListener } from '../../../../../../../actions/subscriber';
import { callTokenApi } from '../../../../../../../apiCaller';
import { API_CLIENT_RULE, RULE_GROUP } from '../../../../../../../constants';
import { toastError } from '../../../../../../../utils';
import CenterSpinner from '../../../../../../general/Loadings/CenterSpinner';
import StepRuleName from '../steps/StepRuleName';
import StepSelectConditionFields from '../steps/StepSelectConditionFields';
import PropTypes from 'prop-types';

const EditFormRule = ({ rule }) => {
     const [stepsData, setStepsData] = useState(cloneDeep(rule));
     return (
          <>
               <StepRuleName stepsData={stepsData} setStepsData={setStepsData} RuleContext={FormRuleSettingContext} mode="edit" />
               <StepSelectConditionFields stepsData={stepsData} setStepsData={setStepsData} RuleContext={FormRuleSettingContext} mode="edit" />
          </>
     );
};

export const FormRuleSettingContext = React.createContext({});

const EditFormRuleSetting = ({ id }) => {
     const dispatch = useDispatch();
     const redirectRules = useSelector((state) => state.subscriber.redirectRules);
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const accountListeners = useSelector((state) => state.subscriber.accountListeners);
     const editingRuleReload = useSelector((state) => state.subscriber.editingRuleReload);
     const formCategoriesRules = useSelector((state) => state.subscriber.formCategoriesRules);
     const activeListener = useSelector((state) => state.subscriber.activeListener);

     const [rule, setRule] = useState();
     const [modal, setModal] = useState(false);
     const [ruleType, setRuleType] = useState('');
     const [activeStep, setActiveStep] = useState(2);
     const [fetchRuleLoading, setFetchRuleLoading] = useState();

     const fetchRule = () => {
          setFetchRuleLoading(true);

          callTokenApi(`${API_CLIENT_RULE}${id}`, 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         const { rule } = response.data;

                         if (rule.accountId !== activeAccount.id) {
                              window.location.href = '/';
                         }
                         setRuleType(rule.type);
                         setRule(rule);

                         const currentListener = accountListeners ? accountListeners.find((listener) => listener.id === rule.listenerId) : null;
                         if (currentListener) {
                              dispatch(setActiveListener(currentListener));
                         }
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    setFetchRuleLoading(false);
               });
     };
     useEffect(fetchRule, [editingRuleReload, accountListeners]); // eslint-disable-line react-hooks/exhaustive-deps

     const fetchAllRules = () => {
          if (!formCategoriesRules) {
               dispatch(fetchAllRulesRequest(activeAccount.id, RULE_GROUP.DATA_LAYER));
          }
     };
     useEffect(fetchAllRules, []); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <>
               {fetchRuleLoading ? (
                    <CenterSpinner />
               ) : (
                    <div className="rule-detail">
                         <div className="cvr-create-new custom-rule">
                              {redirectRules.status && <Redirect to={redirectRules.to} />}
                              {rule && ruleType && (
                                   <>
                                        <h1 className="d-flex">
                                             Edit Form Rule: {rule.name}
                                        </h1>
                                        <p>Use the steps below to configure your rule.</p>
                                        <FormRuleSettingContext.Provider
                                             value={{
                                                  activeStep,
                                                  setRule,
                                                  setActiveStep,
                                                  fetchRule,
                                                  activeListener,
                                             }}
                                        >
                                             <EditFormRule rule={rule}/>
                                        </FormRuleSettingContext.Provider>
                                        <CModal visible={modal} alignment="center" portal={false} onClose={() => setModal(false)}>
                                             <CModalBody className="text-center">
                                                  <h3 className="mb-4">Warning! This Will Change Your Rule</h3>
                                                  <p>
                                                       You are about to change your rule type. Doing this will reset and remove all settings inside
                                                       this rule other than the name and description.
                                                  </p>
                                                  <p>Are you sure you want to do this? You cannot undo this once you publish it!</p>
                                             </CModalBody>
                                             <CModalFooter className="text-center justify-content-center">
                                                  <CButton color="primary" className="mr-3 text-uppercase" onClick={() => setModal(false)}>
                                                       Cancel
                                                  </CButton>
                                                  <CButton color="secondary" onClick={() => {}}>
                                                       Save Change and Reset Rule
                                                  </CButton>
                                             </CModalFooter>
                                        </CModal>
                                   </>
                              )}
                         </div>
                    </div>
               )}
          </>
     );
};


EditFormRuleSetting.propTypes = {
     id: PropTypes.string,
};


EditFormRule.propTypes = {
     rule: PropTypes.any,
};

export default EditFormRuleSetting;
